var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNotify, useRefresh } from "react-admin";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { EScheduledOutcomeKind } from "@sequentech/ui-core";
import { APPLY_SCHEDULE_RECOMPUTE } from "@/queries/Lifecycle";
import { IPermissions } from "@/types/keycloak";
import { getGraphQLActionErrorReason } from "@/services/graphqlActionError";
import { RetainedSignedCloses } from "@/components/timezones/RetainedSignedCloses";
import { useTimeZoneService } from "@/components/timezones/timeZoneService";
/** Groups `get_scheduled_outcomes` by scheduled event. */
export var outcomesByRow = function (rows) {
    var _a;
    var grouped = new Map();
    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
        var row = rows_1[_i];
        grouped.set(row.scheduled_event_id, __spreadArray(__spreadArray([], ((_a = grouped.get(row.scheduled_event_id)) !== null && _a !== void 0 ? _a : []), true), [row], false));
    }
    return grouped;
};
/** Only the transitions at one election, when the list is filtered to it. */
export var outcomesForElection = function (outcomes, electionId) {
    return electionId
        ? new Map(Array.from(outcomes.entries())
            .map(function (_a) {
            var id = _a[0], rows = _a[1];
            return [id, rows.filter(function (row) { return row.election_id === electionId; })];
        })
            .filter(function (_a) {
            var rows = _a[1];
            return rows.length > 0;
        }))
        : outcomes;
};
/** How many transitions (row and Post) will have `outcome`. */
export var outcomeCount = function (outcomes, outcome) {
    return Array.from(outcomes.values())
        .flat()
        .filter(function (_a) {
        var explanation = _a.explanation;
        return explanation.outcome === outcome;
    }).length;
};
/** The scheduled events with at least one Post whose predicted outcome is `outcome`. */
export var outcomeFilterIds = function (outcomes, outcome) {
    return Array.from(outcomes.entries())
        .filter(function (_a) {
        var rows = _a[1];
        return rows.some(function (_a) {
            var explanation = _a.explanation;
            return explanation.outcome === outcome;
        });
    })
        .map(function (_a) {
        var id = _a[0];
        return id;
    });
};
/** The outcomes a banner counts, the strongest first. */
var COUNTED = [
    { outcome: EScheduledOutcomeKind.REFUSED, severity: "error" },
    { outcome: EScheduledOutcomeKind.RUNS_UNSIGNED, severity: "warning" },
];
var COUNT_KEY = (_a = {},
    _a[EScheduledOutcomeKind.REFUSED] = "refused",
    _a[EScheduledOutcomeKind.RUNS_UNSIGNED] = "runsUnsigned",
    _a);
/** The tzdata check's banner: future times a timezone update moved, applied only on request. */
/** The pending tz database change of a row, if any. */
export var recomputeOf = function (event) {
    var _a, _b;
    return (_b = (_a = event.annotations) === null || _a === void 0 ? void 0 : _a.schedule_recompute) !== null && _b !== void 0 ? _b : null;
};
var RecomputeBanner = function (_a) {
    var electionEventId = _a.electionEventId, canApply = _a.canApply, zoneOf = _a.zoneOf, scheduledEvents = _a.scheduledEvents;
    var t = useTranslation().t;
    var service = useTimeZoneService();
    var notify = useNotify();
    var refresh = useRefresh();
    var changed = scheduledEvents.flatMap(function (event) {
        var recompute = recomputeOf(event);
        return recompute ? [{ event: event, recompute: recompute }] : [];
    });
    var _b = useMutation(APPLY_SCHEDULE_RECOMPUTE, {
        context: { headers: { "x-hasura-role": IPermissions.SCHEDULED_EVENT_WRITE } },
    }), apply = _b[0], loading = _b[1].loading;
    var onApply = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apply({ variables: { electionEventId: electionEventId } })];
                case 1:
                    data = (_d.sent()).data;
                    notify(t("lifecycle.schedule.recompute.applied", {
                        count: (_b = (_a = data === null || data === void 0 ? void 0 : data.apply_schedule_recompute) === null || _a === void 0 ? void 0 : _a.updated) !== null && _b !== void 0 ? _b : 0,
                    }), { type: "success" });
                    refresh();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _d.sent();
                    notify((_c = getGraphQLActionErrorReason(error_1)) !== null && _c !== void 0 ? _c : t("lifecycle.schedule.recompute.error"), {
                        type: "error",
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Alert, { severity: "warning", "data-testid": "schedule-recompute", action: canApply ? (_jsx(Button, { color: "inherit", size: "small", disabled: loading, onClick: onApply, children: t("lifecycle.schedule.recompute.apply") })) : undefined, children: [_jsx(Typography, { variant: "body2", children: t("lifecycle.schedule.recompute.title", { count: changed.length }) }), _jsx(Box, { component: "ul", sx: { m: 0, pl: 2 }, children: changed.map(function (_a) {
                    var _b, _c;
                    var event = _a.event, recompute = _a.recompute;
                    var zone = (_b = recompute.timezone) !== null && _b !== void 0 ? _b : zoneOf((_c = event.event_payload) === null || _c === void 0 ? void 0 : _c.election_id);
                    return (_jsx("li", { children: t("lifecycle.schedule.recompute.change", {
                            type: t("eventsScreen.eventType.".concat(event.event_processor)),
                            before: service.formatDateTimeZone(recompute.previous, zone, service.text),
                            after: service.formatDateTimeZone(recompute.scheduled_date, zone, service.text),
                        }) }, String(event.id)));
                }) })] }));
};
/**
 * Above the Scheduled Events list: a timezone update to apply, the totals of
 * openings and closings that won't run as scheduled (each filters the list),
 * changes voters don't see until the next publication, and times without an
 * offset, which never run.
 */
export var ScheduleBanners = function (_a) {
    var electionEventId = _a.electionEventId, outcomes = _a.outcomes, _b = _a.retainedCloses, retainedCloses = _b === void 0 ? [] : _b, _c = _a.retainedUnavailable, retainedUnavailable = _c === void 0 ? false : _c, electionNameOf = _a.electionNameOf, filter = _a.filter, onFilter = _a.onFilter, unpublishedCount = _a.unpublishedCount, published = _a.published, offsetless = _a.offsetless, canApply = _a.canApply, zoneOf = _a.zoneOf, scheduledEvents = _a.scheduledEvents;
    var t = useTranslation().t;
    // Rows, and the election transitions they make (an event-wide row makes one per election).
    var totals = COUNTED.map(function (counted) { return (__assign(__assign({}, counted), { count: outcomeFilterIds(outcomes, counted.outcome).length, transitions: outcomeCount(outcomes, counted.outcome) })); }).filter(function (_a) {
        var count = _a.count;
        return count > 0;
    });
    return (_jsxs(Stack, { spacing: 1, sx: { mx: 2, mb: 1 }, "data-testid": "schedule-banners", children: [_jsx(RetainedSignedCloses, { closes: retainedCloses.filter(function (close) { return !close.fired_at; }), zoneOf: zoneOf, nameOf: electionNameOf !== null && electionNameOf !== void 0 ? electionNameOf : (function () { return t("eventsScreen.fields.electionId"); }), unavailable: retainedUnavailable }), scheduledEvents.some(function (event) { return recomputeOf(event); }) ? (_jsx(RecomputeBanner, { electionEventId: electionEventId, canApply: canApply, zoneOf: zoneOf, scheduledEvents: scheduledEvents })) : null, filter ? (_jsx(Alert, { severity: "info", action: _jsx(Button, { color: "inherit", size: "small", onClick: function () { return onFilter(null); }, children: t("lifecycle.schedule.totals.showAll") }), children: t("lifecycle.schedule.totals.showing.".concat(COUNT_KEY[filter]), {
                    count: outcomeFilterIds(outcomes, filter).length,
                    transitions: outcomeCount(outcomes, filter),
                }) })) : (totals.map(function (_a) {
                var outcome = _a.outcome, severity = _a.severity, count = _a.count, transitions = _a.transitions;
                return (_jsx(Alert, { severity: severity, "data-testid": "schedule-totals-".concat(outcome), action: _jsx(Button, { color: "inherit", size: "small", onClick: function () { return onFilter(outcome); }, children: t("lifecycle.schedule.totals.review") }), children: t("lifecycle.schedule.totals.".concat(COUNT_KEY[outcome]), { count: count, transitions: transitions }) }, outcome));
            })), !published ? (_jsx(Alert, { severity: "info", children: t("lifecycle.schedule.notPublished") })) : unpublishedCount > 0 ? (_jsx(Alert, { severity: "info", "data-testid": "schedule-unpublished", children: t("lifecycle.schedule.unpublishedChanges", { count: unpublishedCount }) })) : null, offsetless > 0 ? (_jsx(Alert, { severity: "warning", "data-testid": "schedule-offsetless", children: t("lifecycle.schedule.offsetless", { count: offsetless }) })) : null] }));
};
